import axios, { AxiosInstance, CreateAxiosDefaults } from "axios";
import { apiTypeUrlBaseGet } from "./api_common";
import { API_TYPES } from "./api_constants";

function axiosInstanceCreate(
  baseURL: string,
  options?: CreateAxiosDefaults<any>
) {
  const axiosInstance = axios.create({ baseURL, ...options });
  return axiosInstance;
}

const authUrlBase: string = apiTypeUrlBaseGet(API_TYPES.AUTH);

export const axiosAuth: AxiosInstance = axiosInstanceCreate(authUrlBase);

const unosRadUrlBase: string = apiTypeUrlBaseGet(API_TYPES.UNOS);

export const axiosUnosRad: AxiosInstance = axiosInstanceCreate(unosRadUrlBase);

axiosUnosRad.interceptors.response.use(null, (err) => {
  if (err.response.status === 401) {
    console.log("interceptor err status 401");
    if (!("" in axiosUnosRad.defaults.headers)) {
      console.log("has no authorization");
      axiosAuth
        .post(
          "bearer/bearer",
          { appName: "express_unos" },
          { withCredentials: true }
        )
        .then((bearerResponse) => {
          console.log("bearerResponse", bearerResponse);
          console.log(
            "interceptor Object.keys(axiosUnosRad.defaults.headers.common).length",
            Object.keys(axiosUnosRad.defaults.headers.common).length
          );
          axiosUnosRad.defaults.headers.common[
            "Authorization"
          ] = `Bearer: ${bearerResponse.data.token}`;
          console.log(
            "interceptor Object.keys(axiosUnosRad.defaults.headers.common).length",
            Object.keys(axiosUnosRad.defaults.headers.common).length
          );
        });
    }
  }
});
